// extracted by mini-css-extract-plugin
export default {"googleLoginButton":"GoogleSignInButton__googleLoginButton___hiqwe"};